import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-orders-active",
  "use": "icon-orders-active-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-orders-active\">\n<path d=\"M14.5 3.25H21C21.41 3.25 21.75 3.59 21.75 4V18C21.75 19.52 20.52 20.75 19 20.75H5C3.48 20.75 2.25 19.52 2.25 18V4C2.25 3.59 2.59 3.25 3 3.25H9.5V13.22C9.5 13.5 9.72 13.72 10 13.72H14C14.28 13.72 14.5 13.5 14.5 13.22V3.25Z\" fill=\"currentColor\" />\n<path d=\"M10.5 3.25H13.5V12.72H10.5V3.25Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol